import { InitialsAvatar } from './InitialsAvatar';

export default InitialsAvatar;
